module.exports = __webpack_public_path__ + "assets/img/theX-speaker.9545cff8.png";